import React from "react";
import { Card, Icon, Image } from "semantic-ui-react";
import "semantic-ui-css/semantic.min.css";
const CardProduct = ({
  image,
  title,
  description,
  price,
  index,
  removeCard,
}) => {
  const closeHandler = () => {
    removeCard(index);
  };
  return (
    <div>
      <Card fluid style={{ padding: 10 }}>
        <div style={{ float: "right" }}>
          <i
            className="fa fa-times-circle"
            aria-hidden="true"
            style={{
              position: "relative",
              float: "right",
              cursor: "pointer",
              /* padding-bottom: 10px; */
              marginBottom: "4px",
            }}
            onClick={closeHandler}
          ></i>
        </div>
        <Image src={image} style={{ height: "22em", width: "100%" }} />
        <Card.Content>
          <Card.Header>{title}</Card.Header>
        </Card.Content>
        <Card.Content extra>
          <a>
            <Icon name="currency" />
            {price}
          </a>
        </Card.Content>
      </Card>
    </div>
  );
};

export default CardProduct;
